// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const MuteOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="MuteOffIcon" ref={forwardedRef} {...props}>
      <path d="M8 5v7h.25l-1.321 1.321A1 1 0 0 1 6.5 12.5v-8a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v2.25L12 8.25V5z" />
      <path d="M13.5 10.993 10.993 13.5H12.5a1 1 0 0 0 1-1z" />
      <path d="M5.753 14.497H5.064V11H3.75l.002 3.998c0 .428.234.793.563.937z" />
      <path d="m8.493 16 1.501-1.501 4.76.001V11h1.496v3.998c0 .553-.517 1.002-1 1.002h-4.504v2h-1.5v-2z" />
      <path d="m3.75 16.498 11.49-11.49 1.061 1.06-11.49 11.49z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const MuteOffIcon = /* @__PURE__ */ Object.assign(MuteOffIconComponent, {
  displayName: 'MuteOffIcon',
});
